import React, { useState, useEffect } from "react";
import { Dialog, Grid, IconButton, Typography } from "@mui/material";
import UsaSsnEinCollection from "./UsaSsnEinCollection";
import CrossIcon from "src/icons/CrossIcon";
import { useUserSlice } from "src/store/features/user.slice";
import ThankYou from "./SsnEinThankYou";
import { useIsMobile } from "src/utils/hooks/useIsMobile";

export default function SsnEinModal() {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const {
    salesforceDetails: { ssnRequired, einRequired, recordType },
    isSubmitted,
  } = useUserSlice();

  // Conditions to open the modal
  useEffect(() => {
    if (ssnRequired) {
      setOpen(true);
    } else if (einRequired) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [ssnRequired, einRequired]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} PaperProps={{ sx: { borderRadius: "10px", width: "600px" } }}>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            backgroundColor: "#002035",
            padding: "16px 20px 16px 20px",
          }}>
          <Grid item xs={10} sx={{ justifyContent: "center", display: "flex" }}>
            {recordType === "Individual" && (
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: isMobile ? "18px" : "23px",
                  fontWeight: "700",
                }}>
                Social Security Number (SSN)
              </Typography>
            )}
            {recordType === "Entity" && (
              <Typography
                sx={{ color: "#FFFFFF", fontSize: isMobile ? "18px" : "23px", fontWeight: "700" }}>
                Employer Identification Number (EIN)
              </Typography>
            )}
          </Grid>
          <Grid item sx={{ justifyContent: "end", display: "flex" }}>
            <IconButton onClick={handleClose}>
              <CrossIcon color="#FFFFFF" width="20px" height="20px" />
            </IconButton>
          </Grid>
        </Grid>
        {/* SSN/EIN collection component */}
        {!isSubmitted && <UsaSsnEinCollection />}
        {/* Thank you component */}
        {isSubmitted && <ThankYou />}
      </Dialog>
    </>
  );
}
